<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div class="flex item-center">
        <el-button type="primary" size="small" @click="addSupplier" v-if="!isBtn('supplierAdd:true')"
          >新增供货商</el-button
        >
        <div
          @click="(openDownLoad) => (downloadVisible = true)"
          class="delete ml20 mr20 pointer"
        >
          <span class="delete-icon hmicon icon-daoru"></span>
          下载模板
        </div>
        <div
          @click="(openExport) => (exportVisible = true)"
          class="delete ml20 mr20 pointer"
        >
          <span class="delete-icon hmicon icon-daochu"></span>
          导入
        </div>
        <div
          @click="allQueryList() , authDialogVisible = true , showType = 1"
          class="delete ml20 mr20 pointer"
          v-if="!isBtn('supplierAuthShow:true')"
                      
        >
          <span class="delete-icon hmicon icon-xitong"></span>
          操作权限配置
        </div>
        <div
          @click="querySupplierdList() , compositeReportVisible = true"
          class="delete ml20 mr20 pointer"
        >
          <span class="delete-icon hmicon icon-daoru"></span>
          导出组合报表
        </div>
        <!-- <div @click="outputExcel" class="delete ml20 mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出经销商模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入经销商
          <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div @click="outputRelShopExcel" class="delete ml20 mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出经销商门店模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入经销商门店
          <input
              type="file"
              @change="importfRelShop"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div @click="outputAgencyEmployeeExcel" class="delete ml20 mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出经销商职员模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入经销商职员
          <input
              type="file"
              @change="importfAgencyEmployee"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div> -->
      </div>
      <div>
        <!-- <el-input
          clearable
          style="width:250px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入登录账户"
          size="small"
          class="ipt mr10"
        ></el-input> -->
        <!-- <el-select
          size="small"
          clearable
          style="width:250px"
          placeholder="请选择服务费扣款方式"
          v-model="searchCondition.percentageMode"
          class="mr10"
          filterable
        >
          <el-option label="按单笔销售申报缴费" value="single"></el-option>
          <el-option label="按提成发放比例缴费" value="ratio"></el-option>
        </el-select> -->

        <el-input
          clearable
          style="width: 250px"
          v-model.trim="keyWords"
          placeholder="请输入供货商名称/供货商编号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <!-- <el-button type="primary" size="small" @click="search">查询</el-button> -->
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        @sort-change="sortChange"
        :data="supplierBasucList"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          fixed
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="供货商名称"
          prop="storeName"
          width="200"
          fixed
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="供货商来源"
          prop="tenantName"
          width="140"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="供货商编号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeType"
          label="类型"
        >
          <template slot-scope="scope">
            {{ scope.row.storeType === "supplier" ? "厂家" : "经销商" }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop=""
          label="当前活动数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop=""
          label="累计红包金额"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="accountBalanceMoney"
          label="账户余额"
          sortable
        >
          <template slot-scope="scope">
            <div>
              <span class="primary">{{ scope.row.accountBalanceMoney }}元</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardNum"
          label="在线活动数量"
          width="100"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relationSpu"
          label="提成计算"
          width="160"
        >
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.percentageMode === 'single'">
              按单笔销售申报缴费
              <div class="primary">{{ scope.row.percentageMoney }}元</div>
            </div> -->
            <div v-if="scope.row.percentageMode === 'ratio'">
              按提成发放比例缴费
              <div class="primary">
                {{ scope.row.percentageRatio }}%,最低服务费{{
                  scope.row.nadirMoney ? scope.row.nadirMoney : "0"
                }}元
              </div>
            </div>
            <div v-if="scope.row.percentageMode === 'pack'">
              按条数缴费，
              <div class="primary">剩余{{ scope.row.accountBalanceNum }}条</div>
            </div>
            <div v-if="scope.row.percentageMode === 'single'">
              按固定金额缴费，
              <div class="primary">每条{{ scope.row.percentageMoney }}元</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="加入日期"
          prop="createTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="主要联系人"
          prop="contactName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="联系电话"
          prop="contactPhone"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          width="400"
          align="center"
          label="操作"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button v-if="!isBtn('supplierAuthShow:true')" size="small" type="text" @click=" checkedCode = scope.row.storeCode , allQueryList1(), authDialogVisible1 = true; showType = 2"
                >授权</el-button
              >
              <el-button v-if="!isBtn('supplierEdit:true')" size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button size="small" type="text" @click="authority(scope.row)"
                >权限管理</el-button
              >
              <el-button size="small" type="text" @click="goCapital(scope.row)"
                >资金流水</el-button
              >
              <el-button size="small" type="text" @click="goShop(scope.row)"
                >门店管理</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="goCategory(scope.row)"
                >品类管理</el-button
              >
              <el-button size="small" type="text" @click="goGoods(scope.row)"
                >商品维护</el-button
              >
              <el-button size="small" type="text" @click="goAct(scope.row)"
                >活动管理</el-button
              >

              <el-button size="small" type="text" @click="goReport(scope.row)"
                >报表</el-button
              >
              <el-button size="small" type="text" @click="goReport1(scope.row)"
                >新报表</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="addDealers(scope.row)"
                >下级经销商管理</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="goAgencyShop(scope.row)"
                v-if="scope.row.storeType == 'agency'"
                >经销商门店管理</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="goStoreShareManage(scope.row)"
                >商户分成管理</el-button
              >
              <el-button size="small" type="text" @click="goMatchAct(scope.row)"
                >搭配活动</el-button
              >
              <!-- <el-button size="small" type="text" @click="getActivityDetails(scope.row)"
                >报名活动明细</el-button> -->
                <el-button size="small" type="text" @click="exportDetails(scope.row)"
                >导出明细</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="60%"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="供货商名称" prop="storeName">
          <el-input
            style="width: 300px"
            clearable
            v-model.trim="ruleForm.storeName"
            maxlength="20"
            size="small"
            placeholder="请输入供货商名称（20文本内）"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="storeType">
          <el-radio-group
            v-model="ruleForm.storeType"
            :disabled="title === '编辑供货商'"
          >
            <el-radio label="supplier">厂家</el-radio>
            <el-radio label="agency">经销商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="供货商简称" prop="storeAbbr">
          <el-input
            style="width: 300px"
            clearable
            v-model.trim="ruleForm.storeAbbr"
            maxlength="20"
            size="small"
            placeholder="请输入供货商简称（20文本内）"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要联系人" prop="contactName">
          <el-input
            style="width: 300px"
            clearable
            v-model.trim="ruleForm.contactName"
            maxlength="20"
            size="small"
            placeholder="请输入主要联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
            style="width: 300px"
            clearable
            type="number"
            v-model.trim="ruleForm.contactPhone"
            maxlength="20"
            size="small"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="contactEmail">
          <el-input
            style="width: 300px"
            clearable
            v-model.trim="ruleForm.contactEmail"
            size="small"
            placeholder="请输入邮箱号"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务费" prop="percentageMode">
          <el-radio-group
            v-model="ruleForm.percentageMode"
            @change="changeMode"
            size="small"
          >
            <el-radio label="ratio">按比例 </el-radio>
            <el-radio label="single">按固定金额</el-radio>
            <el-radio label="pack">按条数</el-radio>
          </el-radio-group>
          <div v-if="ruleForm.percentageMode === 'single'">
            <el-input
              clearable
              v-model.trim="ruleForm.percentageMoney"
              maxlength="20"
              size="small"
              class="mr10"
              @input="filterGt0OrFixed2('percentageMoney')"
              placeholder="请输入金额"
            ></el-input>
            <span>元/条扣除费用，不填写则按照默认价格(1.00元/条)扣除</span>
          </div>
          <div v-if="ruleForm.percentageMode === 'pack'">
            <span> 当条数用完时按照 </span>
            <el-input
              clearable
              v-model.trim="ruleForm.percentageMoney"
              maxlength="20"
              class="mr10"
              size="small"
              @input="filterGt0OrFixed2('percentageMoney')"
              placeholder="请输入金额"
            ></el-input>
            <span>元/条扣除费用，不填写则按照默认价格(1.00元/条)扣除</span>
          </div>
          <div v-if="ruleForm.percentageMode === 'ratio'">
            <el-input
              style="width: 300px"
              clearable
              v-model.trim="ruleForm.percentageRatio"
              maxlength="20"
              @input="filterGt0OrFixed2('percentageRatio')"
              size="small"
              placeholder="请输入服务费比例"
            ></el-input
            >%,最低服务费<el-input
              clearable
              v-model.trim="ruleForm.nadirMoney"
              maxlength="20"
              @input="filterGt0OrFixed2('nadirMoney')"
              size="small"
              placeholder="请输入最低服务费"
            ></el-input
            >元,最高服务费<el-input
              clearable
              v-model.trim="ruleForm.topMoney"
              maxlength="20"
              @input="filterGt0OrFixed2('topMoney')"
              size="small"
              placeholder="请输入最高服务费"
            ></el-input
            >元
          </div>
        </el-form-item>
        <el-form-item label="余额预警" prop="balanceNoticeLine">
          当余额低于
          <el-input
            clearable
            v-model.trim="ruleForm.balanceNoticeLine"
            maxlength="20"
            @input="filterGt0OrFixed2('balanceNoticeLine')"
            size="small"
            placeholder="请输入金额"
          ></el-input
          >元的时候，发送短信预警提醒。
        </el-form-item>
        <el-form-item label="供货商来源" prop="tenantId">
          <el-select
            size="small"
            clearable
            style="width: 300px"
            placeholder="请选择供货商来源"
            v-model="ruleForm.tenantId"
            class="mr10"
            filterable
          >
            <el-option
              :label="v.tenantCompanyName"
              :value="v.tenantId"
              v-for="(v, i) in tenantBasicInfoList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label-width="200px" label="是否允许导购自动加入品牌" prop="configValue">
          <el-radio-group
            v-model="ruleForm.configValue"
            size="small"
          >
            <el-radio label="allow">允许</el-radio>
            <el-radio label="denny">不允许</el-radio>
          </el-radio-group>
          <div style="color: #F56C6C;font-size: 12px;" v-if="ruleForm.configValue == 'denny'">开启限制，需保证品牌唯一，否则限制不生效</div>
         </el-form-item> 
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="errVisible" width="60%" title="导入失败提示">
      <div slot="title">
        <span style="font-size: 18px; color: #303133">导入失败提示</span>
      </div>
      <div>
        <div class="flex flex-between">
          <div class="flex item-center">
            您有
            <span class="error">{{ errList.length }}</span
            >条数据导入失败
            <div @click="outputErrExcel" class="delete pointer ml10">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出失败数据
            </div>
          </div>
          <div>
            您有
            <span class="success"> {{ succList.length }}</span
            >条数据导入成功！
          </div>
        </div>

        <el-table :data="errList" border class="small-table mt10">
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeAbbr"
            label="简称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="contactName"
            label="主要联系人"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="contactPhone"
            label="联系电话"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="contactEmail"
            label="邮箱"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="refuseReason"
            label="失败原因"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="errRelShopVisible"
      width="60%"
      title="导入失败提示"
    >
      <div slot="title">
        <span style="font-size: 18px; color: #303133">导入失败提示</span>
      </div>
      <div>
        <div class="flex flex-between">
          <div class="flex item-center">
            您有
            <span class="error">{{ errRelShopList.length }}</span
            >条数据导入失败
            <div @click="outputRelShopErrExcel" class="delete pointer ml10">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出失败数据
            </div>
          </div>
          <div>
            您有
            <span class="success"> {{ succRelShopList.length }}</span
            >条数据导入成功！
          </div>
        </div>

        <el-table :data="errRelShopList" border class="small-table mt10">
          <el-table-column
            header-align="center"
            align="center"
            prop="agencyName"
            label="经销商名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="refuseReason"
            label="失败原因"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="errEmployeeVisible"
      width="60%"
      title="导入失败提示"
    >
      <div slot="title">
        <span style="font-size: 18px; color: #303133">导入失败提示</span>
      </div>
      <div>
        <div class="flex flex-between">
          <div class="flex item-center">
            您有
            <span class="error">{{ errEmployeeList.length }}</span
            >条数据导入失败
            <div @click="outputEmployeeErrExcel" class="delete pointer ml10">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出失败数据
            </div>
          </div>
          <div>
            您有
            <span class="success"> {{ succEmployeeList.length }}</span
            >条数据导入成功！
          </div>
        </div>

        <el-table :data="errEmployeeList" border class="small-table mt10">
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="经销商名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="username"
            label="用户账号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="用户名字"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="workNum"
            label="工号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="phone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="refuseReason"
            label="失败原因"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="downloadVisible"
      width="40%"
      title="下载模板"
      :close-on-click-modal="false"
    >
      <el-form
        ref="downloadForm"
        :model="downloadForm"
        :rules="downloadRules"
        label-width="100px"
      >
        <el-form-item label="导出类型" prop="downloadType">
          <el-radio-group
            v-model="downloadForm.downloadType"
            :disabled="title === '导出类型'"
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                padding-top: 12px;
              "
            >
              <el-radio style="margin-bottom: 10px" label="1"
                >经销商模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="2"
                >经销商门店模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="3"
                >经销商职员模板</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="dowloadConfirm('downloadForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="downloadVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="exportVisible"
      width="40%"
      title="导入"
      @close="closeExport"
    >
      <el-form
        ref="exportForm"
        :model="exportForm"
        :rules="exportRules"
        label-width="100px"
      >
        <el-form-item label="导入类型" prop="exportType">
          <el-radio-group
            v-model="exportForm.exportType"
            :disabled="title === '导入类型'"
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                padding-top: 12px;
              "
            >
              <el-radio style="margin-bottom: 10px" label="1"
                >经销商模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="2"
                >经销商门店模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="3"
                >经销商职员模板</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '1'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importf"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '2'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importfRelShop"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '3'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importfAgencyEmployee"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="uploadedFile">
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon el-icon-s-order"></span>
            {{ filesName }}
          </div>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="exportConfirm('downloadForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="closeExport"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 操作权限配置/全部用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="操作授权配置"
      width="1000px"
      :visible.sync="authDialogVisible"
      @close="handleDialogClose,keyWords1=''"
    >
      <div class="mb10 flex flex-between">
        <div>
        </div>
        <div>
          <el-input
            clearable
            style="width:250px"
            v-model.trim="keyWords1"
            placeholder="请输入用户名称/用户工号"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search1"
            >查询</el-button>
        </div>
      </div>
      <div>
        <el-table
          :data="allEmployeeList.records"
          style="width: 100%"
          stripe
          border
          size="small"
          :min-height="400"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="职员名称"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="hu"
            label="职员账号"
          ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="workNum"
            label="工号"
          ></el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
              <el-tooltip class="item" content="授权" placement="top">
                <div
                  class="pointer mr10"
                  @click="queryList1(scope.row) , supplierVisible = true "
                >
                  <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                </div>
              </el-tooltip>
            </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="showType==1?allEmployeeList.total:allEmployeeList1.total"
            @current-change="paging1"
            @size-change="handleSizeChange1"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage1"
            :page-size="pageSize1"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
        <!-- 操作权限配置/供货商下面用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增授权"
      width="1000px"
      :visible.sync="authDialogVisible1"
      @close="handleDialogClose,keyWords3=''"
    >
      <div class="mb10 flex flex-between">
        <div>
          <el-button type="primary" size="small" @click="queryList2() , supplierVisible1 = true "
            >新增授权</el-button>
        </div>
        <div>
          <el-input
            clearable
            style="width:250px"
            v-model.trim="keyWords3"
            placeholder="请输入用户名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search2"
            >查询</el-button
          >
        </div>
      </div>
      <div>
        <el-table
          :data="allEmployeeList1.records"
          style="width: 100%"
          stripe
          border
          size="small"
          :min-height="400"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage2 - 1) * pageSize2 + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="职员名称"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="hu"
            label="职员账号"
          ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="workNum"
            label="工号"
          ></el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                 <el-button size="small" type="text" @click="cancelAuth(scope.row)"
                >取消授权</el-button>
            </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="allEmployeeList1.total"
            @current-change="paging2"
            @size-change="handleSizeChange2"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage2"
            :page-size="pageSize2"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
<!-- 操作权限配置/选择供货商 -->
      <el-dialog
        title="操作授权配置"
        :visible.sync='supplierVisible'
        width='940px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        @close="handleDialogClose,keyWords2=''"
        destroy-on-close
      >
        <el-form ref="addForm" :model="addForm" label-width="100px">
            <el-form-item label="可操作对象">
              <div>
                <el-input v-model="keyWords2" class="mr20" clearable placeholder="请输入供货商名称"></el-input><el-button @click="queryList1()" type="primary">查询</el-button>
              </div>
              <hm-base-transfer
                ref="providerTransfer"
                leftName="可选权益"
                rightName="已选权益"
                :leftOption="leftOption2"
                :leftProps="leftProps2"
                :rightOption="rightOption2"
                :rightProps="leftProps2"
                compareKey="storeCode"
                @getTransferResult="getTransferResult2"
              ></hm-base-transfer>
            </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='handleAddConfirm' type='primary' size='small'>确定</el-button>
          <el-button @click='supplierVisible = false' size='small'>取消</el-button>
        </template>
      </el-dialog>
      <!-- 操作权限配置/选择用户 -->
      <el-dialog
        title="新增授权"
        :visible.sync='supplierVisible1'
        width='940px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        @close="handleDialogClose,keyWords4=''"
        destroy-on-close
      >
        <el-form ref="addForm" :model="addForm" label-width="100px">
            <el-form-item label="可操作对象">
              <div>
                <el-input v-model="keyWords4" class="mr20" clearable placeholder="请输入职员名称"></el-input><el-button @click="queryList2()" type="primary">查询</el-button>
              </div>
              <hm-base-transfer
                ref="providerTransfer"
                leftName="可选权益"
                rightName="已选权益"
                :leftOption="leftOption3"
                :leftProps="leftProps3"
                :rightOption="rightOption3"
                :rightProps="leftProps3"
                compareKey="username"
                @getTransferResult="getTransferResult3"
              ></hm-base-transfer>
            </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='handleAddConfirm1' type='primary' size='small'>确定</el-button>
          <el-button @click='supplierVisible1 = false' size='small'>取消</el-button>
        </template>
      </el-dialog>

      <!-- 组合报表导出 -->
      <el-dialog
        title="组合报表导出"
        :visible.sync='compositeReportVisible'
        width='940px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        @close="handleDialogClose"
        destroy-on-close
      >
        <el-form ref="addForm" :model="combinationForm" label-width="100px">
            <el-form-item label="导出报表类型" prop="checkTableTypes">
                <el-checkbox-group v-model="combinationForm.checkTableTypes">
                  <el-checkbox label='goodsDetails'>商品明细</el-checkbox>
                  <el-checkbox label='declareBillDetails'>申报明细</el-checkbox>
                  <el-checkbox label='shopSummary'>门店统计</el-checkbox>
                  <el-checkbox label='guiderSummary'>导购统计</el-checkbox>
                  <el-checkbox label='brandDetails'>品牌</el-checkbox>
                  <el-checkbox label='shareDetails'>分成明细</el-checkbox>
                  <el-checkbox label='refundDetails'>退款明细</el-checkbox>
                  <el-checkbox label='brandDetailsDetails'>品牌明细</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="扣费时间" prop="deductionDate">
                <el-date-picker
                  :default-time="['00:00:00', '23:59:59']"
                  class="mr10"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="combinationForm.deductionDate"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="选择扣费时间段"
                  end-placeholder="选择扣费时间段"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="关联供货商">
              <div>
                <el-input v-model="supplierKeyWords" class="mr20" clearable placeholder="请输入供货商名称"></el-input><el-button @click="querySupplierdList" type="primary">查询</el-button>
                <!-- <el-select
                  size="small"
                  multiple
                  filterable
                  clearable
                  placeholder="选择品牌"
                  v-model="combinationForm.selectbrands"
                  class="width-auto mr10"
                >
                  <el-option
                    v-for="item in brandList"
                    :key="item.shopId"
                    :label="item.shopName"
                    :value="item.shopId"
                  ></el-option>
                </el-select> -->
              </div>
              <hm-base-transfer
                ref="providerTransfer"
                leftName="可选供货商"
                rightName="已选供货商"
                :leftOption="leftOption2"
                :leftProps="leftProps2"
                :rightOption="rightOption2"
                :rightProps="leftProps2"
                compareKey="storeCode"
                @getTransferResult="getTransferResult2"
              ></hm-base-transfer>
            </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='combinationExport' type='primary' size='small'>确定</el-button>
          <el-button @click='handleDialogClose,compositeReportVisible = false' size='small'>取消</el-button>
        </template>
      </el-dialog>
       <el-dialog
      :visible.sync="exportDetailsVisible"
      width="30%"
      title="导出明细"
    >
      <div>
        <span class="mr20">选择导出明细</span>
        <template>
          <el-radio v-model="exportRadio" label="1">报名活动明细</el-radio>
          <el-radio v-model="exportRadio" label="2">导购白名单</el-radio>
        </template>
      </div>
      <template slot='footer'>
          <el-button @click='exportDetailsConfirm' type='primary' size='small'>确定</el-button>
          <el-button @click='exportDetailsVisible = false' size='small'>取消</el-button>
        </template>
    </el-dialog>
  </hm-content>
</template>

<script>
// import { mapGetters } from "vuex";
import XLSX from "xlsx"
import { arrayUnique2, setCookie} from "@/utils/utils";
import { getUserName } from "@/utils/auth";
// import { exportJsonToExcel } from "@/utils/output/Export2Excel";
import HmBaseTransfer from "@/components/HmBaseTransfer";
import { mapGetters } from "vuex";
// import { commonVaribleMixin } from "@/mixins/commonVaribleMixin";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmBaseTransfer,
  },
  // mixins: [commonVaribleMixin],
  data() {
    const validatorFunc = function (rule, val, callback) {
      if ("ratio" == this.ruleForm.percentageMode) {
        if (this.ruleForm.percentageRatio === "") {
          return callback(new Error("请输入服务费比例"));
        } else {
          if (this.ruleForm.percentageRatio > 100) {
            return callback(new Error("缴费比例不能超过100%"));
          }
        }
        if (this.ruleForm.nadirMoney === "") {
          return callback(new Error("请输入最低服务费"));
        }
        // if (this.ruleForm.topMoney && Number(this.ruleForm.topMoney) < 0.5) {
        //   return callback(new Error("最高服务费不能低于0.5元"));
        // }
      } else {
        if (this.ruleForm.percentageMoney == "") {
          return callback(new Error("请输入服务费金额"));
        }
        if (this.upperLimit) {
          if (this.ruleForm.percentageMoney > this.upperLimit) {
            return callback(new Error("服务费金额不能超过" + this.upperLimit));
          }
        }
        if (this.lowerLimit) {
          if (this.ruleForm.percentageMoney < this.lowerLimit) {
            return callback(new Error("服务费金额不能低于" + this.lowerLimit));
          }
        }
      }

      callback();
    }.bind(this);
    return {
      searchCondition: {},
      downloadVisible: false,
      exportVisible: false,
      uploadedFile: false,
      filesName: "",
      ruleForm: {
        storeName: "",
        storeType: "supplier",
        storeAbbr: "",
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        nadirMoney: "",
        percentageRatio: "",
        storePercentageId: "",
        storeCode: "",
        balanceNoticeLine: "",
        tenantId: "",
        percentageMode: "",
        percentageMoney: "",
        topMoney: "",
        configValue:"allow"
      },
      downloadForm: {
        downloadType: "1",
      },
      downloadRules: {
        downloadType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
      },
      exportForm: {
        exportType: "1",
        uploadFile: "",
      },
      exportRules: {
        exportType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
        uploadFile: {
          required: true,
          message: "请上传文件",
          trigger: "blur",
        },
      },
      rules: {
        storeName: [
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur",
          },
        ],
        storeType: {
          required: true,
          message: "请选择类型",
          trigger: "blur",
        },
        contactName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        contactPhone: [
          {
            required: true,
            message: "请输入联系人电话",
            trigger: "blur",
          },
        ],
        contactEmail: [
          {
            required: true,
            message: "请输入邮箱号",
            trigger: "blur",
          },
        ],
        percentageMode: [
          {
            required: true,
            message: "请选择缴费方式",
            trigger: "blur",
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur",
          },
        ],
        balanceNoticeLine: {
          required: true,
          message: "请输入预警金额",
          trigger: "blur",
        },
        tenantId: {
          required: true,
          message: "请选择供货商来源",
          trigger: "blur",
        },
      },
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      title: "",
      tenantBasicInfoList: [],
      supplierBasucList: [],
      total: 0,
      upperLimit: "",
      lowerLimit: "",
      errList: [],
      succList: [],
      errVisible: false,
      errRelShopVisible: false,
      errRelShopList: [],
      succRelShopList: [],
      errEmployeeVisible: false,
      errEmployeeList: [],
      succEmployeeList: [],
      // 6.3添加的属性
      allEmployeeList: [],
      showType: 0,
      authDialogVisible: false,
      authDialogVisible1: false,
      hasAuthList:[
        {realname:"测试",workNum:"56465464"}
      ],
      supplierVisible: false,
      supplierVisible1: false,
      addForm: {
        accountName: "",
        type: "month",
        province: "",
        provider: "",
      },

      leftProps2: [
        {
          name: "供货商名称",
          value: "storeName",
        },
      ],
      leftProps3: [
        {
          name: "职员名称",
          value: "username",
        },
      ],
      currentPage1: 1,
      pageSize1: 10,
      leftOption2: [],
      rightOption2:[],
      leftOption3: [],
      rightOption3:[],
      keyWords: "",
      keyWords1: "",
      keyWords2: "",
      checkedWorknum:'',
      operRuleList:[],
      checkedStore:'',
      allEmployeeList1:[],
      currentPage2: 1,
      pageSize2: 10,
      keyWords3:'',
      checkedCode:'',
      keyWords4:'',

      compositeReportVisible:false, //控制组合报表弹框
      combinationForm:{
        checkTableTypes:[],
        deductionDate:[],
        selectbrands:[]
      },
      // brandList:[],
      supplierKeyWords:'',
      exportDetailsVisible:false,
      exportRadio:'1',
      rowDetail: {}
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryTenantBasicInfoList();
    this.queryRedpackageSupplierPercentageRule();
  },
  mounted() {},
  methods: {
    closeExport() {
      this.exportVisible = false;
      this.uploadedFile = false;
      this.filesName = "";
      this.exportForm = {
        exportType: "1",
        uploadFile: ""
      };
      this.exportVisible = false;
    },
    dowloadConfirm() {
      console.log("导出模板类型", this.downloadForm);
      if (this.downloadForm.downloadType == 1) {
        this.outputExcel();
      } else if (this.downloadForm.downloadType == 2) {
        this.outputRelShopExcel();
      } else if (this.downloadForm.downloadType == 3) {
        this.outputAgencyEmployeeExcel();
      }
    },
    beforeAvatarUpload(file) {
      // 限制上传文件的类型
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        this.$message.error("上传文件只能是 Excel 格式!");
        return false;
      }
      return true;
    },
    exportConfirm() {
      let that = this;
      console.log("导入数据", this.exportForm);
      if (
        this.exportForm.exportType != "" &&
        this.exportForm.uploadFile != ""
      ) {
        if (this.exportForm.exportType == 1) {
          that.$store
            .dispatch("importAgency", this.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                const { failList, successList } = result;
                that.errList = failList;
                that.succList = successList;
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                });
                that.queryList();
                if (failList && failList.length > 0) {
                  that.errList.forEach((v) => {
                    v.refuseReason = "经销商已存在";
                  });
                  that.errVisible = true;
                }
              }
            });
        } else if (this.exportForm.exportType == 2) {
          that.$store
            .dispatch("importAgencyRelShop", this.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                const { errList, succList } = result;
                that.errRelShopList = errList;
                that.succRelShopList = succList;
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                });
                if (errList && errList.length > 0) {
                  that.errRelShopVisible = true;
                }
              }
            });
        } else if (this.exportForm.exportType == 3) {
          that.$store
            .dispatch("importAgencyEmployeeInfo", this.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                const { errList, succList } = result;
                that.errEmployeeList = errList;
                that.succEmployeeList = succList;
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                });
                if (errList && errList.length > 0) {
                  that.errEmployeeVisible = true;
                }
              }
            });
        }
      } else {
        this.$message({
          message: "请选择导入模板类型和上传文件",
          type: "warning",
        });
      }
    },
    outputEmployeeErrExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "经销商名称",
          "用户账号",
          "用户名字",
          "工号",
          "手机号",
          "失败原因",
        ];
        const filterVal = [
          "storeName",
          "username",
          "realname",
          "workNum",
          "phone",
          "refuseReason",
        ];
        const data = this.formatJson(filterVal, this.errEmployeeList);

        exportJsonToExcel(tHeader, data, "经销商职员导入失败数据");
      });
    },
    //经销商职员导入
    importfAgencyEmployee(e) {
      // const obj = e.target;
      const that = this;
      this.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      if (!e.raw) {
        return;
      }
      // let f = obj.files[0];
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              username: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              realname: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              workNum: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              phone: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
              orgName: "总部",
              ruleList: [{ ruleName: "经销商" }],
            });
          }
        });

        console.log("formatResult", formatResult);
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      e.value = "";
    },
    outputAgencyEmployeeExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "经销商名称",
          "用户账号",
          "用户名字",
          "工号",
          "手机号",
        ];
        const data = [];

        exportJsonToExcel(tHeader, data, "经销商职员模板");
        this.downloadVisible = false;
      });
    },
    outputRelShopErrExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["经销商名称", "商户名", "失败原因"];
        const filterVal = ["agencyName", "storeName", "refuseReason"];
        const data = this.formatJson(filterVal, this.errRelShopList);

        exportJsonToExcel(tHeader, data, "经销商关联门店导入失败数据");
      });
    },
    //关联门店导入
    importfRelShop(e) {
      // const obj = e.target;
      const that = this;
      this.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      if (!e.raw) {
        return;
      }
      // let f = obj.files[0];
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach((v) => {
          if (v[0] && v[1]) {
            formatResult.push({
              agencyName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        console.log("formatResult", formatResult);
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      e.value = "";
    },
    //导出关联门店模版excel
    outputRelShopExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["经销商名称(必填)", "商户名(必填)"];
        const data = [];

        exportJsonToExcel(tHeader, data, "经销商门店模板");
        this.downloadVisible = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    outputErrExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "经销商名称(必填)",
          "简称",
          "主要联系人",
          "联系电话",
          "邮箱",
          "失败原因",
        ];
        const filterVal = [
          "storeName",
          "storeAbbr",
          "contactName",
          "contactPhone",
          "contactEmail",
          "refuseReason",
        ];
        const data = this.formatJson(filterVal, this.errList);

        exportJsonToExcel(tHeader, data, "经销商导入失败数据");
      });
    },
    importf(e) {
      console.log(e);
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (obj.files[0]) {
      //   return
      // }
      if (!e.raw) {
        return;
      }
      // let f = obj.files[0];
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeType: "agency",
              storeAbbr: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              contactName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "【无】",
              contactPhone: v[3]
                ? (v[3] + "").replace(/\s*/g, "")
                : "18000000000",
              contactEmail: v[4]
                ? (v[4] + "").replace(/\s*/g, "")
                : "test@hemiao100.com",
              percentageMode: "ratio",
              percentageRatio: "3",
              nadirMoney: "2",
              balanceNoticeLine: "0",
              tenantId: "b5d9c3a100b44d5993689925f8baf319",
            });
          }
        });

        formatResult = arrayUnique2(formatResult, "storeName");

        console.log("formatResult", formatResult);
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;

        // that.$store.dispatch("importAgency", formatResult).then((res) => {
        //   const { code, result } = res;
        //   if (code === "0") {
        //     const { failList, successList } = result;
        //     that.errList = failList;
        //     that.succList = successList;
        //     that.$message({
        //       message: "操作成功",
        //       type: "success",
        //     });
        //     that.queryList();
        //     if (failList && failList.length > 0) {
        //       that.errList.forEach((v) => {
        //         v.refuseReason = "经销商已存在";
        //       });
        //       that.errVisible = true;
        //     }
        //   }
        // });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      e.value = "";
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "经销商名称(必填)",
          "简称",
          "主要联系人",
          "联系电话",
          "邮箱",
        ];
        const data = [];

        exportJsonToExcel(tHeader, data, "经销商模板");
        this.downloadVisible = false;
      });
    },
    //去往经销商门店管理
    goAgencyShop(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "AgencyShopManage",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    //去商户分成管理
    goStoreShareManage(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "SupplierStoreShareManage",
        query: {
          storeCode: row.storeCode,
          accountType: row.accountType,
        },
      });
    },
    //修改服务费类型
    changeMode() {
      this.ruleForm.percentageMoney = "";
      this.ruleForm.percentageRatio = "";
      this.ruleForm.nadirMoney = "";
    },
    //获取商户抽佣的上下限规则
    async queryRedpackageSupplierPercentageRule() {
      const { result } = await this.$store.dispatch(
        "queryRedpackageSupplierPercentageRule"
      );
      if (this.isArray(result)) {
        result.forEach((v) => {
          if ("upperLimit" == v.itemText) {
            this.upperLimit = v.itemValue;
          } else if ("lowerLimit" == v.itemText) {
            this.lowerLimit = v.itemValue;
          }
        });
      }
    },
    //判断是否为数组
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryTenantBasicInfoList() {
      const { code, result } = await this.$store.dispatch(
        "tenantBasicInfoList"
      );

      if (code === "0") {
        this.tenantBasicInfoList = result.records;
        this.queryList();
      }
    },
    sortChange(sort) {
      Object.assign(this.searchCondition, sort);

      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    search1() {
      this.currentPage1 = 1;
      this.allQueryList();
    },
    search2() {
      this.currentPage2 = 1;
      this.allQueryList1();
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.nadirMoney = "";
      this.ruleForm.storeCode = "";
      this.ruleForm.storePercentageId = "";
      this.ruleForm.percentageRatio = "";
    },
    async queryList() {

        let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "storeBasicInfofindAuthSupplierBasicListl",
        params
      );
      if (code === "0") {
        result.records.forEach((v) => {
          this.tenantBasicInfoList.forEach((o) => {
            if (o.tenantId === v.tenantId) {
              v.tenantName = o.tenantCompanyName;
            }
          });
        });

        this.supplierBasucList = result.records;
        this.total = result.total;
      }

    },
    async authSearch() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "querySupplierBasicList",
        params
      );
      if (code === "0") {
        result.records.forEach((v) => {
          this.tenantBasicInfoList.forEach((o) => {
            if (o.tenantId === v.tenantId) {
              v.tenantName = o.tenantCompanyName;
            }
          });
        });

        this.supplierBasucList = result.records;
        this.total = result.total;
      }
    },
    addSupplier() {
      this.title = "新增供货商";
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    paging1(page) {
      this.currentPage1 = page;
      this.allQueryList();
    },
    paging2(page) {
      this.currentPage2 = page;
      this.allQueryList1();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSizeChange1(size) {
      this.currentPage1 = 1;
      this.pageSize1 = size;
      this.allQueryList();
    },
    handleSizeChange2(size) {
      this.currentPage2 = 1;
      this.pageSize2 = size;
      this.allQueryList1();
    },
    edit(row) {
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
      this.$store.dispatch("detailsSupplierBasicInfo", row).then((res) => {
        if (res.code === "0") {
          for (let key in this.ruleForm) {
            if (res.result.hasOwnProperty(key)) {
              this.ruleForm[key] = res.result[key];
            }
          }
          if(res.result.supplierConfigModels && res.result.supplierConfigModels.length > 0) {
            this.ruleForm.configValue = res.result.supplierConfigModels[0].configValue;
          }
        }
      });
      this.title = "编辑供货商";
      this.dialogVisible = true;
    },
    authority(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "AuthorityManagement",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goShop(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "ShopManage",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    addDealers(row) {
      localStorage.setItem("storeName", row.storeName);
      let rows = JSON.stringify(row);
      this.$router.push({
        name: "MistributorManagement",
        query: {
          storeCode: row.storeCode,
          rows,
        },
      });
    },
    goReport(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "ReportForms",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goReport1(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "ReportnewForms",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goAct(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "ActivityManagement",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goMatchAct(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "MatchActivityManagement",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goCapital(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "CapitalFlow",
        query: {
          storeCode: row.storeCode,
          percentageMode: row.percentageMode,
        },
      });
    },
    goCategory(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "CategoryMaintenance",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goGoods(row) {
      localStorage.setItem("storeName", row.storeName);
      this.$router.push({
        name: "GoodsMaintenance",
        query: {
          storeCode: row.storeCode,
        },
      });
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleForm;
          let name =
            this.title === "新增供货商"
              ? "saveSupplierBasicInfo"
              : "editSupplierBasicInfo";
          console.log("params", params);
          let info = {
            configValue: this.ruleForm.configValue,
            supplierCode: this.ruleForm.storeCode,
            useScene: "supplierDenyAddBrand"
          }
          this.$store.dispatch("supplierSetConfig", info);
          this.$store.dispatch(name, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.dialogVisible = false;
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },

    // 2024.6.3添加的方法

    //   setParamsCookie() {
    //   let searchCondition = {
    //     keyWords: this.keyWords,
    //     // orgCode: this.orgCode,
    //     workingState: this.workingState,
    //     syncFlag: this.syncFlag
    //   };
    //   setCookie({
    //     key: "employeeListParams",
    //     type: "session",
    //     data: Object.assign({}, searchCondition, {
    //       pageSize: this.pageSize1,
    //       currentPage: this.currentPage1
    //     })
    //   });
    // },
    allQueryList() {
        this.$store.dispatch("queryAllEmployeeList", {
        pageNo: this.currentPage1,
        pageSize: this.pageSize1,
        queryKey: this.keyWords1,
        workingState: 'yes',
        loginType: "store"
        }).then((res) => {
        if (res.code === "0") {
          this.allEmployeeList = res.result
        }
      });
    },
    allQueryList1() {
        this.$store.dispatch("queryAccountInfoPageList", {
        pageNo: this.currentPage2,
        pageSize: this.pageSize2,
        keyword: this.keyWords3,
        queryAuthSupplierCodeList : [this.checkedCode],
        }).then((res) => {
        if (res.code === "0") {
          this.allEmployeeList1 = res.result
        }
      });
    },
    async queryList1(row) {
      let params = {
        pageSize: 9999,
        pageNo: 1,
        keyWords: this.keyWords2,
        createTimeEnd: "",
        createTimeStart: "",
      };
      if (!this.keyWords2) {
        delete params.keyWords;
      }
      console.log(params);
      const { code, result } = await this.$store.dispatch(
        "querySupplierBasicList",
        params
      );
      if (code === "0") {
        // result.records.forEach((v) => {
        //   this.tenantBasicInfoList.forEach((o) => {
        //     if (o.tenantId === v.tenantId) {
        //       v.tenantName = o.tenantCompanyName;
        //     }
        //   });
        // });
        // this.allSupplier = result.records;
        this.leftOption2 = result.records
        if(row&&this.keyWords2==''){
          this.checkedWorknum = row.username
          this.getSupplierWorkConfigqueryPageList()
        }
      }
    },
    getTransferResult2(list) {
      console.log("list2::", list);
      this.rightOption2 = list
    },
    getTransferResult3(list) {
      console.log("list2::", list);
      this.rightOption3 = list
    },
    handleDialogClose() {
      this.addForm = {
        accountName: "",
        type: "month",
        province: "",
        provider: "",
      }
      this.combinationForm={
        checkTableTypes:[],
        deductionDate:'',
        selectbrands:[]
      }
      this.supplierKeyWords = ''
    },
    async queryList2() {
      this.$store.dispatch("queryAllEmployeeList", {
        pageNo: 1,
        pageSize: 99999999,
        queryKey: this.keyWords4,
        workingState: 'yes',
        loginType: "store"
      }).then((res) => {
        if (res.code === "0") {
          this.leftOption3 = res.result.records
          if(this.keyWords4==''){
            this.getSupplierWorkConfigqueryPageList1()
          }
        }
  
      });
    },
    getTransferResult2(list) {
      console.log("list2::", list);
      this.rightOption2 = list
    },
    handleDialogClose() {
      this.addForm = {
        accountName: "",
        type: "month",
        province: "",
        provider: "",
      };
      this.combinationForm={
        checkTableTypes:[],
        deductionDate:'',
        selectbrands:[]
      }
      this.supplierKeyWords = ''
    },
    getSupplierWorkConfigqueryPageList(){
      console.log(this.leftOption2.length)
      this.$store.dispatch("queryAccountInfoPageList", {
        account: this.checkedWorknum,
        pageNo: 1,
        pageSize: 999999,
      }).then((res) => {
        console.log(this.leftOption2.length+'全部的长度')
        console.log((res.result.records[0].authSupplierCodeGroup.split(',')).length+'选中的长度')
        let storeArr = res.result.records[0].authSupplierCodeGroup.split(',')
        if (res.code === "0") {
          let rightOption2 = []
          console.log(res.result.records+'res')
          if(res.result.records.length>0){
            storeArr.forEach((item1,index1)=>{
              this.leftOption2.forEach((item2,index2)=>{
                if(item1 == item2.storeCode){
                  console.log(item1)
                  this.leftOption2.splice(index2, 1);
                  rightOption2.push(item2)
                }
                })
            })
          }
          this.rightOption2 = rightOption2
        }
      });
    },
    getSupplierWorkConfigqueryPageList1(){
      this.$store.dispatch("queryAccountInfoPageList", {
        queryAuthSupplierCodeList : [this.checkedCode],
        pageNo: 1,
        pageSize: 999999,
      }).then((res) => {
        if (res.code === "0") {
          let rightOption3 = []
          console.log(res.result.records+'res')
          if(res.result.records.length>0){
            res.result.records.forEach((item1,index1)=>{
              this.leftOption3.forEach((item2,index2)=>{
                if(item1.account == item2.username){
                  this.leftOption3.splice(index2, 1);
                  rightOption3.push(item2)
                }
                })
            })
          }
          this.rightOption3 = rightOption3
        }
      });
    },
    handleAddConfirm(){
      let that = this;
      let rightOption2 = []
      this.rightOption2.forEach((item)=>{
        let item1 = {}
        item1.workType = "user_name"
        item1.workValue = that.checkedWorknum
        item1.configType = "auth_supplier_code"
        item1.configValue = item.storeCode
        rightOption2.push(item1)
      })
      that.$store.dispatch("supplierWorkConfigrefreshWorkConfig", {
        workType:"user_name",
        workValue:that.checkedWorknum,
        configType:"auth_supplier_code",
        operRuleList:rightOption2
      }).then((res) => {
        if (res.code === "0") {
          that.$nextTick(() => {
                  this.supplierVisible = false
                  this.authDialogVisible = false
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });

          });
        }
      });
    },
    handleAddConfirm1(){
      let that = this;
      let rightOption3 = []
      this.rightOption3.forEach((item)=>{
        let item1 = {}
        item1.workType = "user_name"
        item1.workValue = item.username
        item1.configType = "auth_supplier_code"
        item1.configValue = that.checkedCode
        rightOption3.push(item1)
      })
      that.$store.dispatch("refreshWorkConfigBySupplier", {
        workType:"user_name",
        configValue:that.checkedCode,
        configType:"auth_supplier_code",
        operRuleList:rightOption3
      }).then((res) => {
        if (res.code === "0") {
          that.$nextTick(() => {
            this.supplierVisible1 = false
            this.authDialogVisible1 = false
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
          });
        }
      });
    },
    cancelAuth(row){
      this.$confirm("是否取消?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
            .dispatch("supplierWorkConfigremoveByModel", { 
              configType: "auth_supplier_code",
              configValue: this.checkedCode,
              workType: "user_name",
              workValue: row.account 
            }).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.allQueryList1();
              }
            });
      });
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    getActivityDetails(row){
      this.$store.dispatch("exportCustomReport", { 
               reportCode: "DIANZAN_NEW_EXPORT",
               param:{
               store_code: row.storeCode,
               }
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "已加入导出队列正在生成报表，请在导出列队中查看！",
                  type: "success",
                });
              }
            });
    },
    exportAllowAutoBrandList(row){
      this.$store.dispatch("exportAllowAutoBrandList", { 
            supplierCode: row.storeCode,
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "已加入导出队列正在生成报表，请在导出列队中查看！",
                type: "success",
              });
            }
          });
    },
    exportDetails(row) { 
      this.rowDetail = row
      this.exportDetailsVisible = true
    },
    exportDetailsConfirm() {
      if(this.exportRadio == '1') {
        this.getActivityDetails(this.rowDetail)
      }
      if(this.exportRadio == '2') {
        this.exportAllowAutoBrandList(this.rowDetail)
      }
      this.exportDetailsVisible = false
    }, 
    async querySupplierdList() {
      this.rightOption2 = []
      console.log(this.supplierKeyWords)
      let params = {
        pageSize: 9999,
        pageNo: 1,
        keyWords: this.supplierKeyWords,
        createTimeEnd: "",
        createTimeStart: "",
      };
      if (!this.supplierKeyWords) {
        delete params.keyWords;
      }
      console.log(params);
      const { code, result } = await this.$store.dispatch(
        "querySupplierBasicList",
        params
      );
      if (code === "0") {
        result.records.forEach((v) => {
          this.tenantBasicInfoList.forEach((o) => {
            if (o.tenantId === v.tenantId) {
              v.tenantName = o.tenantCompanyName;
            }
          });
        });
        this.allSupplier = result.records;
        this.leftOption2 = result.records.slice(0, 9999);
        console.log("---result.records---", result.records);
      }
    },
    // 报表组合导出
   async combinationExport(){
      console.log('this.combinationForm.checkTableTypes',this.combinationForm.checkTableTypes)
      if(this.combinationForm.checkTableTypes.length<=0){
        this.$message({
          message: "至少选择一种报表类型!",
          type: "warning"
        });
        return
      }
      console.log('this.combinationForm.deductionDate',this.combinationForm.deductionDate)
      if(this.combinationForm.deductionDate.length<=0){
        this.$message({
          message: "请选择扣费时间!",
          type: "warning"
        });
        return
      }
      if(this.rightOption2.length<=0){
        this.$message({
          message: "请选择供货商!",
          type: "warning"
        });
        return
      }
      let supplierCodeList = []
      this.rightOption2.forEach((item)=>{
        supplierCodeList.push(item.storeCode)
      })
      let params = {
         operUsername: localStorage.getItem("username"),
         reportTypeList: this.combinationForm.checkTableTypes,
         supplierCodeList: supplierCodeList,
         tradeTimeEnd: this.combinationForm.deductionDate[1],
         tradeTimeStart: this.combinationForm.deductionDate[0]
      }
      const { code } = await this.$store.dispatch("exportCompositeEs", params);
      if(code === "0"){
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success",
          });
          this.compositeReportVisible = false
          // this.$refs.hmcontent.flag = false;
          this.handleDialogClose()
        }, 0);
      }else{
        this.$message({
          message: "导出失败!",
          type: "warning"
        });
      }
   }
  }
};
</script>
<style lang="scss" scoped>
</style>
